module.exports = __webpack_public_path__ + "static/media/AI_Predict_Star.31633dc2.svg";